<template>
    <div class="skeleton"></div>
</template>

<script setup>

</script>

<style scoped>
.skeleton {
    background: linear-gradient(90deg, #eee, #f5f5f5, #eee);
    background-size: 200% 100%;
    animation: skeleton-loading 1.2s infinite;
    border-radius: 4px;

    width: 100%;
}

@keyframes skeleton-loading {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}
</style>